export * from "./social-links";
export { SocialLinks as default } from "./social-links";
